import i18n from '../i18n/index';
export const t = (key: string) => {
  const text = i18n.global.t(key);
  return text === key ? '' : text;
};
